import { SVGProps } from 'react';

// Icons the UI spec (§16) defines that no heroicons component matches: the
// phone outline path filled white (the call button) and the copy glyph.

const PHONE_PATH =
  'M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z';

const COPY_PATH =
  'M8 3.5A1.5 1.5 0 0 1 9.5 2h7A1.5 1.5 0 0 1 18 3.5v11a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 8 14.5v-11Zm1.5 0v11h7v-11h-7ZM5 7.5A1.5 1.5 0 0 1 6.5 6v1.5V18.5h8.5V20H6.5A1.5 1.5 0 0 1 5 18.5v-11Z';

export const PhoneFilledIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
    <path d={PHONE_PATH} />
  </svg>
);

export const CopyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
    <path d={COPY_PATH} />
  </svg>
);
